module.exports = __webpack_public_path__ + "css/UNDP.5e587b63.css";